export default "/images/file.svg?4e21aac2a5e21cc12159bfa63974c9d8";